
import { 
    EDIT_CASE,
    EDIT_CASE_SUCCESS,
    EDIT_CASE_FAIL, 
    EDIT_CASE_RESET,
} from "../actions/editCaseAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const editCaseReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_CASE:
            return {
                ...state,
                apiState: "loading",
            };
        case EDIT_CASE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case EDIT_CASE_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case EDIT_CASE_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default editCaseReducer;
